<template>
    <section  class="main-page">
        <section class="page-section q-pa-md" >
            <div class="container-fluid">
                <div class="grid ">
                    <div class="col comp-grid" >
                        <div class="" >
                            <div class="flex align-items-center ">
                                <div class="ml-2">
                                    <div class="text-2xl font-bold">CapsOverview</div>
                                </div>
                            </div>
                        </div>
                        <hr class="my-3" />
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>
<script>
	import { PageMixin } from "../../mixins/page.js";
	export default {
		name: 'capsoverviewPage',
		components: {
		},
		mixins: [PageMixin ],
		props: {
		},
		data: function() {
			return {
				ready: false,
			}
		},
		computed: {
			pageTitle:{
				get: function () {
					return "Capsoverview"
				}
			},
		},
		methods: {
		},
		watch: {
		},
		async mounted() {
			this.ready = true;
		},
		async created (){
		}
	};
</script>
<style scoped>
</style>
